import src from "IMAGE";
export default { src, width: 683, height: 683, blurWidth: 0, blurHeight: 0};
